let dtcClick = document.querySelector('#dtc-click-rev');
let element = document.querySelector('#dtc-scroll');
let header = document.querySelector('#header');  // Replace '#header' with the selector for your header
if (dtcClick){
    dtcClick.addEventListener('click', function() {
        let rect = element.getBoundingClientRect();
        let headerHeight = header.offsetHeight;
        window.scrollTo({ top: rect.top + window.scrollY - headerHeight, behavior: "smooth" });
    });
}